export default {
  'header.product': 'ផលិតផល', 'header.customers': 'អតិថិជន', 'header.advertise': 'ផ្សព្វផ្សាយ', 'header.pricing': 'តម្លៃ',
  'header.signIn': 'ចូលគណនី', 'header.startFree': 'ចាប់ផ្តើមឥតគិតថ្លៃ', 'header.toggleMenu': 'បើកឬបិទម៉ឺនុយ', 'header.language': 'ប្តូរភាសា',
  'header.solutions': 'ដំណោះស្រាយ', 'header.solutionsText': 'ផែនការតាមវិស័យ និងតួនាទី',
  'header.features': 'មុខងារ', 'header.featuresText': 'ពិន្ទុ រង្វាន់ កម្រិតសមាជិក និងច្រើនទៀត',
  'header.customersText': 'ក្រុមការងារដែលរីកចម្រើនជាមួយកម្មវិធីភក្តីភាព',
  'header.security': 'សុវត្ថិភាព', 'header.securityText': 'របៀបការពារទិន្នន័យសមាជិក',
};
